export default {
  addMeal: `mutation addMeal($name: String!){
    addMeal(name: $name){
      id
      name
      dietInfo {
        id
        name
      }
    }
  }`,

  addMenuEvent: `mutation addMenuEvent($office: Int!, $date: String!, $event: Int!, $time: String!){
    addMenuEvent(office: $office, date: $date, event: $event, time: $time){
      id
      office
      date
      event
      time
      mealsInfo{
        id
        name
        dietInfo{
          id
          name
        }
      }
    }
  }`,

  addMenuEventMeal: `mutation addMenuEventMeal($meal: Int!, $menuEvent: Int!){
    addMenuEventMeal(meal: $meal, menuEvent: $menuEvent){
      meal
      menuEvent
    }
  }`,

  editMeal: `mutation editMeal($id: Int!, $name: String!){
    editMeal(id: $id, name: $name){
      id
      name
      dietInfo{
        id
        name
      }
    }
  }`,

  saveWeeklyMenu: `mutation saveWeeklyMenu($menu: MenuInput!){
    saveWeeklyMenu(menu: $menu){
      id
      office
      date
      event
      time
      mealsInfo{
        name
        dietInfo{
          id
          name
        }
      }
    }
  }`,
};



// WEBPACK FOOTER //
// ./src/graphql/mutations/weeklyMenu.js